'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('antd/lib/select/style');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Option = _select2.default.Option;

var SelectWidget = function (_Component) {
  _inherits(SelectWidget, _Component);

  function SelectWidget() {
    _classCallCheck(this, SelectWidget);

    return _possibleConstructorReturn(this, (SelectWidget.__proto__ || Object.getPrototypeOf(SelectWidget)).apply(this, arguments));
  }

  _createClass(SelectWidget, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (typeof nextProps.value === 'number') {
        nextProps.onChange(nextProps.value.toString());
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _select2.default,
        {
          defaultValue: this.props.placeholder,
          allowClear: true,
          placeholder: this.props.schema.label + ' \u0441\u043E\u043D\u0433\u043E\u0445',
          value: this.props.value ? typeof this.props.value === 'number' ? this.props.value.toString() : this.props.value : this.props.value,
          required: this.props.required,
          disabled: this.props.disabled,
          onChange: function onChange(value) {
            return _this2.props.onChange(value);
          }
        },
        this.props.schema.options.map(function (_ref, i) {
          var _id = _ref._id,
              name = _ref.name,
              parent = _ref.parent;

          var returnObject = void 0;
          if (_this2.props.schema.parent && _this2.props.schema.parent.length) {
            var parentValue = void 0;
            try {
              parentValue = _this2.props.schema.parent.reduce(function (result, key) {
                if (result) return result[key];
                throw new Error('Object not found');
              }, _this2.props.formContext);
            } catch (error) {
              parentValue = false;
            }
            returnObject = parent === parentValue ? _react2.default.createElement(
              Option,
              { key: i, value: _id },
              name
            ) : undefined;
          } else {
            returnObject = _react2.default.createElement(
              Option,
              { key: i, value: _id },
              name
            );
          }
          return returnObject;
        })
      );
    }
  }]);

  return SelectWidget;
}(_react.Component);

SelectWidget.defaultProps = {
  value: undefined,
  placeholder: '',
  options: {},
  formContext: {},
  disabled: false
};

SelectWidget.propTypes = {
  value: _propTypes2.default.any,
  required: _propTypes2.default.bool.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  schema: _propTypes2.default.object.isRequired,
  placeholder: _propTypes2.default.string,
  options: _propTypes2.default.object,
  formContext: _propTypes2.default.object,
  disabled: _propTypes2.default.bool
};

exports.default = SelectWidget;


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/Form/Widgets/SelectWidget/index.js
// module id = 961
// module chunks = 0